export default __webpack_public_path__ + "static/media/unlocked.6475de66.svg";